import React from "react";
import VerticalPage from "@/verticals/VerticalPage";
import { santeData } from "@/verticals/verticalData";

export default function SantePage() {
  return <VerticalPage data={santeData} />;
}
